















































































































import moment from 'moment';
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import DepartamentSelect from '@/modules/reservation/components/DepartamentSelect.vue';
import Department from '@/modules/reservation/model/Department';
import User from '@/modules/user/model/User';
import UserSelect from '@/modules/user/components/UserSelect.vue';
import {Action, Mutation, State} from 'vuex-class';
import {PaginationInput} from '@/modules/core/model/pagination';
import {ReservationPaginationFilters} from '@/modules/reservation/api';
import DepartmentTypeSelect from '@/modules/reservation/components/DepartmentTypeSelect.vue';
import {Prop} from 'vue-property-decorator';

/**
 * Widget que permite al usuario filtrar la lista de reservas por diferentes valores
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {DepartmentTypeSelect, UserSelect, DepartamentSelect},
})
export default class ReservationListFilters extends Vue {
    /**
     * Controla la visibilidad del botón que permite cerrar el diálogo de filtros
     */
    @Prop({type: Boolean, default: false})
    public displayCloseButton: boolean

    /**
     * Parámetros actuales para solicitar la paginación de reservas
     */
    @State(state => state.reservation.reservationPaginationInput)
    public paginationInput: PaginationInput<ReservationPaginationFilters>;

    /**
     * Establece la información para solicitar una paginación que será utilizada si se invoca
     * la acción loadReservationPagination
     */
    @Mutation('reservation/SET_RESERVATION_PAGINATION_INPUT')
    public setReservationPaginationInput: (input: PaginationInput<ReservationPaginationFilters>) => void;

    /**
     * Limpia los filtros actuales de los parámetros de la paginación, vuelve a su estado
     * inicial.
     */
    @Mutation('reservation/CLEAR_RESERVATION_PAGINATION_INPUT_FILTERS')
    public clearPaginationFilters: () => void;

    /**
     * Carga una paginación en función de los parámetros de entrada actuales, definidos
     * por PaginationInput
     */
    @Action('reservation/loadReservationPagination')
    public loadPagination: () => void;

    public departmentSelect = false;
    public department = new Department();

    public userSelect = false;
    public user = new User();

    /**
     * Estilos del contenedor donde se encuentran los controles para los
     * filtros
     */
    public get cardTextStyles () {
        const offset = this.$vuetify.breakpoint.xs ? 102 : 212
        return {
            height: `calc(100vh - ${offset}px)`,
            overflow: 'auto',
        };
    }

    /**
     *  Resetea el usuario actual.
     */
    public resetUser() {
        this.changePagination('userId', null)
        this.user = new User()
    }

    public resetDepartmentFilter () {
        this.changePagination('department', 0)
        this.department = new Department()
    }

    /**
     * Actualiza un campo de los parámetros de paginación
     */
    public debounceUpdateInputField = _.debounce(function (this: ReservationListFilters, field: string, value: any) {
        this.changePagination(field, value);
    }, 400);

    /**
     * Nombre del departamento completo con el nombre del tipo
     */
    public get departmentName () {
        return this.department.id ? `${this.department.name} de ${this.department.type.name}` : '';
    }

    /**
     * Actualiza un campo de los parámetros de paginación
     */
    public async changePagination (field: string, value: any) {
        const input = _.cloneDeep(this.paginationInput);
        // El valor es vacío o igual al actual, se detiene el proceso
        if (_.get(input.filters!, field) === value) {
            return;
        }

        switch (field) {
            case 'startDate':
            case 'endDate':
                _.set(input.filters!, field, !value ? null : moment(value, 'YYYY-MM-DD').toDate());
                break;
            default:
                _.set(input.filters!, field, value);
        }

        this.setReservationPaginationInput(input);

        await this.loadPagination();
    }

    /**
     * Método invocado cuando el usuario selecciona un departamento desde la pantalla de
     * selección
     *
     * @param event
     */
    public async onDepartmentSelect (event: Department) {
        this.department = event;
        this.departmentSelect = false;

        await this.changePagination('department', event.id);
    }

    /**
     * Método invocado cuando un usuario selecciona un usuario desde la
     * pantalla de usuario
     */
    public async onUserSelect (event: User) {
        this.user = event;
        this.userSelect = false;

        await this.changePagination('userId', event.id);
    }

    /**
     * Limpia los filtros de búsqueda carga una paginación nueva
     */
    public async reset () {
        // Los filtrado de búsqueda ya se encuentra vacíos
        if (this.paginationInput.filters!.areClean) {
            return;
        }

        this.user = new User();
        this.department = new Department();

        this.clearPaginationFilters();
        await this.loadPagination();
    }
}
